import React, { useEffect, useRef } from 'react'
import styles from "./RegistrationForm.module.css"
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom'
import { useState } from 'react'
import { BreathAPIs } from '../APIs/BreathAPIs'

import { connect } from 'react-redux'
import { setAlert } from '../Actions/Alert'
import { register } from '../Actions/Auth'
import PropTypes from 'prop-types'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import BreatheEV_Logo from '../Images/logo.png';
import { Image } from 'react-bootstrap'
import Alert from '../BootstrapComponents/Alert';
import { Button } from 'antd';
import LegalDoc from './LegalDoc';
import PhoneVerificationModal from './PhoneVerificationModal'
import { IoCheckbox } from "react-icons/io5";
import { BsInfoCircleFill } from "react-icons/bs";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { MdOutlineQrCodeScanner } from "react-icons/md"
import PhoneInput from '../components/PhoneInput'
import QRCodeScanner from '../components/QRCodeScanner'
import { extractLocationCodeFromScan, isValidLocationCode } from '../Utils/locationCode'


const RegistrationForm = ({ setAlert, register }) => {

  const [previous, setPrevious] = useState(true)
  const [next, setNext] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [isUserCreated, setIsUserCreated] = useState(null);
  const [userCreatedName, setUserCreatedName] = useState('');
  const [userCreatedEmail, setUserCreatedEmail] = useState('');

  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(null);
  const [isCheckingPhone, setIsCheckingPhone] = useState(false);


  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [receive_sms_updates, setReceiveSMSUpdates] = useState(false);
  const [receive_promotional_messages, setReceivePromotionalMessages] = useState(false);
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [location, setLocation] = useState('')
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState('');
  const [fetchedLocations, setFetchedLocations] = useState([]);
  const [inprogress, setInprogress] = useState(false);
  const [legalDoc, setLegalDoc] = useState(false);
  const [legalDocVisible, setLegalDocVisible] = useState(false);
  const [legalDocType, setLegalDocType] = useState('');
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(AiOutlineEye);
  const timeoutRef = useRef(null);

  const [flag, setFlag] = useState(false);

  const { selectedLocation, lan, lon, couponCode } = useParams();
  const [locationCode, setLocationCode] = useState(selectedLocation ? selectedLocation : '');
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [coordinates, setCoordinates] = useState([0, 0]);

  const [couponData, setCouponData] = useState(null);


  const navigate = useNavigate();

  const locationUrl = useLocation();
  const isPublic = locationUrl.pathname?.split("/").pop() === "public";




  // useEffect(() => {
  //   fetchLocations();
  // }, [])
  // const fetchLocations = async () => {
  //   try {
  //     const res = await BreathAPIs.getRegistrationLocations();
  //     console.log(res.data)
  //     setFetchedLocations(res.data);
  //   } catch (error) {
  //     console.log(error)
  //   }

  // }
  const userDetails = {
    firstName,
    lastName,
    email: email?.toLocaleLowerCase(),
    phone,
    isPhoneNumberVerified,
    receive_sms_updates,
    receive_promotional_messages,
    password,
    location,
    company: company || null,
    coordinates,
    welcomeCoupon : couponData?.couponCode ? couponData?.couponCode : ''
  }

  useEffect(() => {

    if (lan !== undefined && lon !== undefined) {
      setLocationCode('');
      setCoordinates({ lan, lon });
    }

  }, [lan, lon])


  //const testUser ={"firstName":"jyo","lastName":"44","email":"jyo45@jyo.com","password":"123456"}
  //   const togglePasswordView = ()=>{

  //     if(type==='password'){
  //         setIcon(AiOutlineEyeInvisible);
  //         setType('text');
  //     }
  //     else{
  //         setIcon(AiOutlineEye);
  //         setType('password')
  //     }
  // }

  const handleMouseDown = () => {

    timeoutRef.current = setTimeout(() => {
      setIcon(AiOutlineEyeInvisible);
      setType('text');


    }, 100);

    // console.log('Mouse down');
  };

  const handleMouseUp = () => {

    setIcon(AiOutlineEye);
    setType('password')
    clearTimeout(timeoutRef.current);
    // console.log('Mouse up');
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const [locationData, setLocationData] = useState([]);
  const [isCheckingLocationCode, setIsCheckingLocationCode] = useState(!!selectedLocation);
  const [isRedirectingToThirdParty, setIsRedirectingToThirdParty] = useState(false);

  const checkLocationCodeAndRedirectIfNeeded = async (code) => {
    setIsCheckingLocationCode(true);
    try {
      const selLocation = await BreathAPIs.checkLocationCode(code, { includeRedirectCode: true });
      const fetchedLocation = selLocation?.data[0];

      if (fetchedLocation?.enableThirdPartyRedirect && fetchedLocation?.thirdPartyRedirectUrl && fetchedLocation?.redirectCodeId === code) {
        setIsRedirectingToThirdParty(true);
        setTimeout(() => {
          window.location.href = fetchedLocation.thirdPartyRedirectUrl;
        }, 2000);
        return;
      }

      setLocationData(fetchedLocation);
      setIsCheckingLocationCode(false);
    } catch (error) {
      console.error('Error fetching location code:', error);
      setIsCheckingLocationCode(false);
    }
  };

  useEffect(() => {
    if (selectedLocation) {
      checkLocationCodeAndRedirectIfNeeded(selectedLocation);
    } else {
      setIsCheckingLocationCode(false);
    }
  }, [selectedLocation]);

  // useEffect(() => {

  //   if (locationData && locationData.public) {
  //     navigate(`/registration/loc/coordinates/${locationData?.coordinates[1]}/${locationData?.coordinates[0]}`);
  //   }

  // }, [locationData, navigate])


  const [couponDataLoading, setCouponDataLoading] = useState(false);
  const checkCouponValid = async (couponCode, locationId) => {
    try {
  
      setCouponDataLoading(true)
      const resultCoupon = await BreathAPIs.checkCouponValidWithLocation(couponCode, locationId);
  
      if (resultCoupon?.status === 200 && resultCoupon?.data?.data) {
        setCouponData(resultCoupon.data.data);
      } else {
        setCouponData(null);
        console.error(resultCoupon?.data?.message || "Invalid coupon.");
      }
    } catch (error) {
      setCouponData(null);
      console.error(error.response?.data?.message || "Error checking coupon. Please try again.");
    }
    finally {
      setCouponDataLoading(false)
    }
  };
  
  useEffect(() => {
    if (couponCode && locationData?._id) {
      checkCouponValid(couponCode, locationData?._id);
    } 
    else if(couponCode && selectedLocation === undefined){
      checkCouponValid(couponCode, null);
    }
    else {
      setCouponData(null);
    }
  }, [couponCode, locationData, selectedLocation]);
  



  const handleQRScan = (scannedText) => {
    const code = extractLocationCodeFromScan(scannedText);
    if (!isValidLocationCode(code)) {
      return false;
    }
    setLocationCode(code);
    setShowQRScanner(false);
    checkLocationCodeAndRedirectIfNeeded(code);
    return true;
  };

  const onClickNext = async () => {
    setInprogress(true);
    if (firstName === '' || lastName === '') {
      setAlert("Please fill in all the fields.", 'danger')
    }
    else if (locationCode !== null && locationCode !== "" && !isValidLocationCode(locationCode)) {
      setAlert("Invalid Location code. Please enter 6 uppercase letters.", 'danger');
    }
    else {
      try {
        if (locationCode !== "") {
          const selLocation = await BreathAPIs.checkLocationCode(locationCode);

          if (!selLocation || selLocation.data.length === 0) {
            setAlert("Code is not valid", 'danger');
          } else {
            const firstLocation = selLocation.data[0];
            const companies = [...new Set(selLocation.data.flatMap((loc) => loc.companies || []))];
            setCompanyOptions(companies);
            setCompany((prev) => companies.includes(prev) ? prev : '');
            setLocation(
              prev => [
                ...prev,
                ...selLocation.data.map((location) => { return location._id })
            ]);
            setNext(true);
            setPrevious(false);
          }
        } else {
          setLocation([]);
          setCompanyOptions([]);
          setCompany('');
          setNext(true);
          setPrevious(false);
        }

      } catch (error) {
        const errorMessage = error.response?.data?.error?.msg || "Code is not valid";
        setAlert(errorMessage, 'danger');
      }
    }

    setInprogress(false);
  }

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return false;
  
    const [localPart, domain] = email.split("@");
  
    if (domain.toLowerCase() === "breathe-ev.com") {
      return true;
    }
  
    return !localPart.includes("+");
  }

  function isValidPassword(password) {
  if (password.length < 12) {
    return false;
  }

  const hasUppercase = /[A-Z]/.test(password);

  const hasNumber = /\d/.test(password);

  return hasUppercase && hasNumber;
}

  const onSubmit = async (e) => {
    e.preventDefault()
    // console.log(JSON.stringify(userDetails))
    console.log("phone length: ", typeof(phone), "\n", "len: ",  phone.length)
    console.log("!/^\d+$/.test(phone)", !/^\d+$/.test(phone))
    console.log("!((phone.length === 10) || (phone.length === 0))", !((phone.length === 10) || (phone.length === 0)))
    try {
      if (email == '' || password == '' || password2 == '') {
        setAlert("Please fill in all the fields.", 'danger');
      }
      else if (!isValidEmail(email)) {
        setAlert("Please enter a valid email address.", 'danger');
      }
      else if(!isValidPassword(password)) {
        setAlert("Password must be atleast 12 characters long, with atleast one uppercase letter and one number.", 'danger');
      }
      else if (password != password2) {
        setAlert("Passwords do not match.", 'danger');
      }
      else if (companyOptions.length > 0 && !company) {
        setAlert("Please select your company.", 'danger');
      }
      else if(!isPhoneNumberVerified){
        setAlert("Please verify your phone number.", 'danger')
      }
      else if (!legalDoc) {
        setAlert("Please accept privacy policy.", 'danger');
      }
      else if ( ((phone.length !== 0 && !/^\d+$/.test(phone)) || !((phone.length === 10) || (phone.length === 0)))) {
        setAlert("Please enter a valid phone number", 'warning');
      }
      else {
        // const res = await BreathAPIs.registerUser(userDetails)
        // console.log(res.data)

        setInprogress(true);

        //redux
        const res = await register(userDetails);
        setInprogress(false);
        if (res) {
          setUserCreatedName(firstName);
          setUserCreatedEmail(email);
          setLocationCode('');

          setIsUserCreated(true);
          setFirstName('')
          setLastName('')
          setEmail('')
          setPhone('')
          setReceiveSMSUpdates(false)
          setReceivePromotionalMessages(false)
          setPassword('')
          setPassword2('')
          setCompanyOptions([])
          setCompany('')

          setNext(false)
          setPrevious(true)
          setFlag(true)
          setLegalDoc(false)
        }
      }
    }
    catch (err) {
      setInprogress(false);
      setAlert(err.message, 'danger');
    }

  }

  const [showPhoneVerificationModal, setShowPhoneVerificationModal] = useState(false);
  const handleCheckboxChange = async () => {
    setIsCheckingPhone(true);
    try {
      let isPhoneUnique = await BreathAPIs.checkIfPhoneUniqueForRegistration(phone)
      console.log("isPhoneUnique", isPhoneUnique)
      if (phone && !isPhoneUnique.data.ok) {
        setAlert("Phone already exists", "danger")
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      }
      else if (!/^\d+$/.test(phone) || !(phone.length === 10)) {
        setAlert("Please enter a valid phone number", 'warning');
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      } else {
        setShowPhoneVerificationModal(true);
        setReceiveSMSUpdates(false);
        setIsPhoneNumberVerified(false);
      }
    } finally {
      setIsCheckingPhone(false);
    }
  };

  const handleVerificationSuccess = () => {
    setReceiveSMSUpdates(true);
    setIsPhoneNumberVerified(true);
  };

  const sanitizePhoneNumber = (input) => {
    const sanitized = input.replace(/\D/g, '');
    return sanitized.startsWith('1') ? sanitized.slice(1) : sanitized;
};


  if (isCheckingLocationCode) {
    return (
      <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
              <div className="mb-5">
                <div className="text-center mb-4">
                  <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
                </div>
              </div>
              <div className="card border border-light-subtle rounded-4">
                <div className={`card-body p-3 p-md-4 p-xl-5 text-center ${styles['loader-body']}`}>
                  <div className={`spinner-border ${styles['loader-spinner']}`} role="status">
                    <span className="visually-hidden">{isRedirectingToThirdParty ? 'Redirecting...' : 'Checking location code...'}</span>
                  </div>
                  <p className={styles['loader-text']}>{isRedirectingToThirdParty ? 'Redirecting...' : 'Checking location code...'}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className={isUserCreated !== true ? "col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4" : ""}>
            <div className="mb-5">
              <div className="text-center mb-4">
                <Image className={styles['logo']} src={BreatheEV_Logo} alt="" />
              </div>
            </div>
            <div className="card border border-light-subtle rounded-4">
              <div className="card-body p-3 p-md-4 p-xl-5">
                <form onSubmit={onSubmit}>
                  {isUserCreated !== true && <h5 className={`mb-4 ${styles['login-title']}`}>Sign Up</h5>}
                  {isUserCreated !== true && <Alert></Alert>}
                  <div className="row gy-3 overflow-hidden">
                    {isUserCreated && <>

                      <div className={`col-12 ${styles['user-created-notes']}`}>
                        <h5 className={`mb-4 ${styles['login-title']}`}>Welcome to BreatheEV - Account Created Successfully!</h5>
                        <p>Dear <strong>{userCreatedName}</strong>,</p>
                        <p>Congratulations! Your account on BreatheEV has been successfully created. We're thrilled to have you on board.</p>
                        <p>To ensure the security of your account, please take a moment to verify your email address by following the steps below:</p>
                        <ol>
                          <li><strong>Check Your Email:</strong> We've sent a verification email to <strong>{userCreatedEmail}</strong>. Please check your inbox and spam folder.</li>
                          <li><strong>Verify Within 24 hours:</strong> For security reasons, the verification link is only valid for the next 24 hours. Kindly ensure that you complete the verification process within this timeframe.</li>
                          <li><strong>Click the Verification Link:</strong> Open the email from BreatheEV and click on the provided verification link.</li>
                          <li><strong>Enjoy Full Access:</strong> Once your email is verified, you'll have full access to all the features and benefits of BreatheEV.</li>
                        </ol>
                        <p>Thank you for choosing BreatheEV. If you encounter any issues or have questions, feel free to reach out to our support team at <a href="mailto:info@breathe-ev.com">info@breathe-ev.com</a>.</p>
                        <p>Best Regards,<br />
                          The BreatheEV Team</p>
                      </div>

                    </>}
                    {isUserCreated !== true && previous && (
                      <>
                        <div className="col-12">
                          <div className="form-floating mb-3">
                            <input className="form-control" type="text" name="first_name" placeholder='First Name' onChange={(e) => { setFirstName(e.target.value); }} value={firstName} required />
                            <label htmlFor="first_name" className="form-label">First Name</label>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-floating mb-3">
                            <input className="form-control" type="text" name="last_name" placeholder='Last Name' onChange={(e) => { setLastName(e.target.value); }} value={lastName} required />
                            <label htmlFor="last_name" className="form-label">Last Name</label>
                          </div>
                        </div>

                        {!(couponCode && selectedLocation === undefined) && !isPublic && (
                          <div className="col-12">
                            <div className={styles['input-info']}><BsInfoCircleFill /><span>Leave blank if public user</span></div>
                            <div className="form-floating mb-3">
                              {selectedLocation ? (
                                <span className="form-control bg-light">{locationCode}</span>
                              ) : (
                                <>
                                  <input
                                    id="locationCode"
                                    className={`form-control ${styles['form-control-qr']}`}
                                    type="text"
                                    name="locationCode"
                                    placeholder="Location Code"
                                    onChange={(e) => setLocationCode(e.target.value.toUpperCase())}
                                    value={locationCode}
                                  />
                                  <button
                                    type="button"
                                    className={styles['qr-scan-icon']}
                                    onClick={() => setShowQRScanner(true)}
                                    aria-label="Scan location QR code"
                                  >
                                    <MdOutlineQrCodeScanner />
                                  </button>
                                </>
                              )}
                              <label htmlFor="locationCode" className="form-label">Location Code</label>
                            </div>
                            {!selectedLocation && (
                              <QRCodeScanner
                                open={showQRScanner}
                                onClose={() => setShowQRScanner(false)}
                                onScan={handleQRScan}
                                title="Scan Location QR Code"
                              />
                            )}
                          </div>
                        )}


                        {(couponData && couponData?.couponCode) && (
                          <div className="col-12">
                            {/* Display Benefit Amount Message */}
                            <div className={styles['input-info']}>
                              <BsInfoCircleFill />
                              <span>Coupon code applied!</span>
                            </div>

                            {/* Display Coupon Code */}
                            <div className="form-floating mb-3">
                              <span className="form-control bg-light">{couponData.couponCode}</span>
                              <label className="form-label">Coupon Code</label>
                            </div>
                          </div>
                        )}



                        <div className="col-12">
                          <div className="d-grid">
                            <ButtonCustom
                              variant={"primary"}
                              text={"Next"}
                              isLoading={inprogress || couponDataLoading}
                              onClick={onClickNext} />
                          </div>
                        </div>
                      </>
                    )}

                    {isUserCreated !== true && next && (
                      <>
                        {companyOptions.length > 0 && (
                          <div className="col-12">
                            <div className="form-floating mb-3">
                              <select id="company" className="form-select" name="company" value={company} onChange={(e) => setCompany(e.target.value)} required>
                                <option value="" disabled>Select your company</option>
                                {companyOptions.map((c) => <option key={c} value={c}>{c}</option>)}
                              </select>
                              <label htmlFor="company" className="form-label">Company</label>
                            </div>
                          </div>
                        )}
                        <div className="col-12">
                          <div className="form-floating mb-3">
                            <input className="form-control" type="email" name="email" placeholder='Email' onChange={(e) => { setEmail(e.target.value); }} value={email} required />
                            <label htmlFor="email" className="form-label">Email</label>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className={`form-floating mb-3 input-left-box ${styles['input-left-box']}`}>
                            {isPhoneNumberVerified ? <div className="form-control">{'+1' + phone}</div> : <PhoneInput addCode={true} className="form-control" type="text" name="phone" placeholder='Phone' onChange={(e) => { setPhone(sanitizePhoneNumber(e.target.value)); }} value={phone} required />}
                            <span className={styles['left-box-component']}>+1</span>
                            <label htmlFor="phone" className="form-label">Phone</label>
                          </div>

                          {showPhoneVerificationModal && (
                            <PhoneVerificationModal
                              closeModal={() => setShowPhoneVerificationModal(false)}
                              onVerificationSuccess={handleVerificationSuccess}
                              modalVisible={showPhoneVerificationModal}
                              phoneNumber={phone}
                            />
                          )}
                        </div>

                        <div className="col-12">
                          <div className="form-floating mb-3">
                            <input className={`form-control ${styles['form-control-pass']}`} type={type} name="password" placeholder='Password' onChange={(e) => { setPassword(e.target.value); }} value={password} required />
                            {/* <i className={styles['pass-view-icon']} onClick={togglePasswordView}>{icon}</i> */}
                            <div className={styles['pass-view-icon']} onTouchStart={handleMouseDown} onTouchEnd={handleMouseUp} onTouchMove={handleMouseUp} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} >{icon}</div>
                            <label htmlFor="password" className="form-label">Password</label>
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="form-floating mb-3">
                            <input className="form-control" type="password" name="password2" placeholder=' Re-enter Password' onChange={(e) => { setPassword2(e.target.value); }} value={password2} required />

                            <label htmlFor="password2" className="form-label"> Re-enter Password</label>
                          </div>
                        </div>

                        <div className="col-12">
                          {!isPhoneNumberVerified ? <label className={styles['sms-checkbox']}>
                            {!isCheckingPhone && <input checked={isPhoneNumberVerified} className="form-check-input" type={'checkbox'} onChange={handleCheckboxChange} disabled={isCheckingPhone} />}
                            {isCheckingPhone
                              ? <><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>Please verify your phone number to complete registration.</>
                              : 'Please verify your phone number to complete registration.'
                            }
                          </label>
                            :
                            <label className={styles['sms-checkbox']}>
                              <IoCheckbox /> Phone number ({'+1' + phone}) verified. Expect charging session updates via SMS.
                            </label>}
                        </div>

                        
                        {/* {isPhoneNumberVerified && 
                          <div className="col-12">
                            <label className={styles['sms-checkbox']}>-
                              <input
                                checked={receive_sms_updates}
                                className="form-check-input"
                                type="checkbox"
                                onChange={(e) => setReceiveSMSUpdates(e.target.checked)}
                              />
                              Get real-time charging alerts and helpful reminders so you never miss a charge. Msg frequency varies. Msg & data rates may apply. Reply STOP to opt out, HELP for help, or manage in profile.
                            </label> 
                          </div>
                        } */}

                        {
                          <div className="col-12">
                            <label className={styles['sms-checkbox']}>
                              <input
                                checked={receive_promotional_messages}
                                className="form-check-input"
                                type="checkbox"
                                onChange={(e) => setReceivePromotionalMessages(e.target.checked)}
                              />
                              Get BreatheEV offers & updates by SMS. Msg & data rates may apply. Reply STOP to opt out. Consent not required.
                            </label>
                          </div>
                        }


                        <div className="col-12">
                          <label className={styles['privacy-policy-check-box']}>
                            <input checked={legalDoc} className="form-check-input" type={'checkbox'} onChange={() => setLegalDoc(!legalDoc)} />
                            I accept the
                            <button onClick={() => { setLegalDocType('terms-of-service'); setLegalDocVisible(true); }} style={{ paddingLeft: 2, paddingRight: 2 }} type="button">Terms of Use</button>
                            and have read the
                            <button onClick={() => { setLegalDocType('privacy-policy'); setLegalDocVisible(true); }} style={{ paddingLeft: 2, paddingRight: 2 }} type="button">Privacy Notice</button>
                          </label>
                          <LegalDoc type={legalDocType} modalVisible={legalDocVisible} closeModal={() => { setLegalDocVisible(false); }} />
                        </div>


                        <div className="col-12">
                          <div className="d-grid">
                            <ButtonCustom
                              variant={"primary"}
                              text={"Create"}
                              isLoading={inprogress}
                              onClick={onSubmit}></ButtonCustom>
                          </div>
                        </div>
                      </>
                    )}

                  </div>
                </form>
              </div>
            </div>
            <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
              <Link className="link-secondary text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}/login`}>{isPublic ? 'Sign In' : 'Back to  Log in'}</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

}

RegistrationForm.propTypes = {
  setAlert: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired
};

export default connect(null, { setAlert, register })(RegistrationForm)